import React, { ComponentProps } from 'react'
import Styles from './RarumDialog.module.scss'
import AdaptiveDialog from '@onepercentio/one-ui/components/AdaptiveDialog'
import Button from '@onepercentio/one-ui/components/Button'
import Spacing from '@onepercentio/one-ui/components/Spacing'
import IconRarum from 'components/IconRarum'
import Text from 'openspace/components/Text'
import { LPTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import { RARUM_DIALOG_TEST_IDS } from './RarumDialog.e2e'

/**
 * Standardize dialog
 **/
export default function RarumDialog({
  title,
  children,
  confirm,
  cancel,
  onClose,
  ...props
}: ComponentProps<typeof AdaptiveDialog> & {
  title: [icon: ComponentProps<typeof IconRarum>['icon'], label: string]
} & {
  [k in 'confirm' | 'cancel']?: [
    lbl: string,
    ClickActions<'onClick'>['onClick']
  ]
}) {
  return (
    <AdaptiveDialog {...props} onClose={onClose} className={Styles.root}>
      <div className={`${Styles.title} ${onClose ? '' : Styles.center}`}>
        <IconRarum icon={title[0]} size={40} />
        <Text type={LPTypo.H4}>{title[1]}</Text>
      </div>
      <Spacing size='16' />
      <div>{children}</div>
      <Spacing size='16' />
      {(confirm || cancel) && (
        <div className={Styles.actions}>
          {cancel && (
            <Button
              data-testid={RARUM_DIALOG_TEST_IDS.CANCEL_ACTION}
              variant='outline'
              onClick={cancel[1]}>
              {cancel[0]}
            </Button>
          )}
          {confirm && (
            <Button
              data-testid={RARUM_DIALOG_TEST_IDS.CONFIRM_ACTION}
              variant='filled'
              color='primary'
              onClick={confirm[1]}>
              {confirm[0]}
            </Button>
          )}
        </div>
      )}
    </AdaptiveDialog>
  )
}
